/*
 * @Author: Josselin Hubert
 * @Date: 2020-09-03 13:49:37
 * @Last Modified by: Josselin Hubert
 * @Last Modified time: 2020-09-11 00:05:15
 */


import Vue from 'vue';

export default {



  test() {
    // return Vue.axios.post('http://127.0.0.1:3000/utils/captcha', payload);
    return Vue.axios.get('/utils/test');
  },

  testLocal() {
    // return Vue.axios.post('http://127.0.0.1:3000/utils/captcha', payload);
    return Vue.axios.post('/utils/testlocal');
  },


  captcha2(payload) {
    return Vue.axios.post('/utils/captcha2', payload);
  },

  captcha3(payload) {
    return Vue.axios.post('/utils/captcha3', payload);
  },

  sendMail(payload) {
    return Vue.axios.post('/utils/sendmail', payload);
  },

}
